(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initSliders = () => {
    document.querySelectorAll('.ba_slider__swiper__v2').forEach((slider) => {
      const id = slider.dataset.sliderId;

      new Swiper(slider, {
        slidesPerView: 1.05,
        spaceBetween: 30,
        loop: true,
        centerInsufficientSlides: true,
        navigation: {
          nextEl: `.next-${id}`,
          prevEl: `.prev-${id}`,
        },
        pagination: {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true
        },
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 3.05,
          },
        },
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initSliders);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"]) return;
  try {
    
  const baSlider = () => {
    new Swiper('.ba_slider__swiper', {
      slidesPerView: 1.3,
      spaceBetween: 15,
      centerInsufficientSlides: true,
      scrollbar: {
        el: ".ba_slider__swiper .swiper-scrollbar",
        freeMode: true,
        draggable: true,
        hide: false
      },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        768: {
          slidesPerView: "auto",
        },
      },
    })
  }
  document.addEventListener('DOMContentLoaded', baSlider)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands-info"] && !Shopify.designMode) return;
  try {
    
  let brandSlider
  const brandsSwiper = () => {
    brandSlider = new Swiper('.brands-info_swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      freeMode: true,
      autoplay: {
        delay: 1500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 4.3,
          spaceBetween: 10,
          loop: true,
          freeMode: false,
        }
      },
      navigation: {
        nextEl: '.brands-info_swiper .swiper-button-next',
        prevEl: '.brands-info_swiper .swiper-button-prev',
      },
    });
  }
  function onResize() {
    const windowWidth = window.innerWidth;
    if (windowWidth >= 768) {
      brandSlider.disable();
    } else {
      brandSlider.enable();
      brandSlider.update();
      brandsSwiper();
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    brandsSwiper();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pads-tech"]) return;
  try {
    
  const bundleSlider = () => {
    new Swiper('.blundleSlider', {
      slidesPerView: 1.1,
      freeMode: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        600: {
          slidesPerView: 'auto',
        },
      },
      pagination: {
        el: '.blundleSlider .swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      watchOverflow: true,
      spaceBetween: 25,
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    bundleSlider();
  });

  } catch(e) { console.error(e); }
})();
})();
